import { Combobox } from "@headlessui/react";
import React, { useEffect, useMemo, useState } from "react";
import CurrencyInput from "react-currency-input-field";
import { ArrowLeft, Check } from "react-feather";
import { useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import Button from "../../../../components/common/Button";
import SelectComponent from "../../../../components/common/Select";
import { useSendMoneyContext } from "../../../../contexts/send-money";
import {
  default as RestService,
  default as restService,
} from "../../../../services/restService";
import { Title } from "./components/title";

const SendMoney = () => {
  const {
    sendMoneyData: { disbursal_country },
    agentCommission,
    setAgentCommission,
    companyCommission,
    setCompanyCommission,
    agencyCommission,
    setAgencyCommission,
    charge,
    setCharge,
    agentCommissionAmount,
    setAgentCommissionAmount,
    companyCommissionAmount,
    setCompanyCommissionAmount,
    agencyCommissionAmount,
    setAgencyCommissionAmount,
    receiveAmount,
    setReceiveAmount,
    amountToPay,
    setAmountToPay,
    rate,
    setRate,
    rateRecord,
    setRateRecord,
    transactionCharge,
    setTransactionCharge,
    agencyCurrency,
    setCurrentStep,
    sendAmount,
    setSendAmount,
    setTransferReason,
    transferReason,
  } = useSendMoneyContext();

  const agent = useSelector((state) => state.auth?.user);
  const { addToast } = useToasts();

  const [rates, setRates] = useState([]);
  const [searchReasonQuery, setSearchReasonQuery] = useState("");
  const [transferReasons, setTransferReasons] = useState([]);

  const getCharge = () => {
    RestService.TransactionsApi.getChargeByAmount(
      sendAmount,
      agent?.agency?.country.currency_code,
      disbursal_country?.currency_code,
      agent?.agency?.id,
      agent?.id
    )
      .then(({ data }) => {
        const charges = data?.data;
        let chargeAmount = 0;

        if (charges) {
          // Preserve full charge response (with id) for submission
          setTransactionCharge(charges);
          chargeAmount =
            charges.fixed_charge_amount +
            (sendAmount * charges.percentage_charge_amount) / 100;
          setCharge(chargeAmount);
        }
      })
      .catch(() => {
        setTransactionCharge(null);
        setCharge(0);
      });
  };

  useEffect(() => {
    getCharge();
  }, [sendAmount]);

  const getChargeAsync = async (amount) => {
    return await RestService.TransactionsApi.getChargeByAmount(
      amount,
      agent?.agency?.country.currency_code,
      disbursal_country?.currency_code,
      agent?.agency?.id,
      agent?.id
    );
  };

  useEffect(() => {
    RestService.TransactionsApi.getRates(
        agent?.agency?.country.currency_code,
        disbursal_country?.currency_code
    ).then(({ data }) => {
      const firstRate = data?.data?.data?.[0];
      setRate(firstRate?.rate ? firstRate.rate : 1);
      // Preserve the selected rate record (with id) for submission
      setRateRecord(firstRate ?? null);
    });

    restService.RatesApi.getRatesBySourceCurrency(
        agent?.agency?.country.currency_code
    )
      .then(({ data }) => {
        setRates(data?.data?.data);
      })
      .catch(() => {});

    restService.UtilsApi.getTransferReasons()
      .then(({ data }) => {
        setTransferReasons(data?.data);
      })
      .catch(() => {});

    restService.CommissionsConfigApi.getCommissionConfigurationByAgency(
      agent?.agency?.id
    ).then(({ data }) => {
      setAgencyCommission(data?.data.data?.[0]?.agency_percentage);
      setAgentCommission(data?.data.data?.[0]?.agent_percentage);
      setCompanyCommission(data?.data.data?.[0]?.company_percentage);
      // setCommissionConfigurationId(data?.data.data?.[0]?.id);
    });
  }, []);

  useEffect(() => {
    setAgentCommissionAmount(
      agentCommission ? (agentCommission / 100) * charge : 0
    );
    setAgencyCommissionAmount(
      agencyCommission ? (agencyCommission / 100) * charge : 0
    );
    setCompanyCommissionAmount(
      companyCommission ? (companyCommission / 100) * charge : 0
    );
  }, [charge, agentCommission, agencyCommission]);

  const handleReasonSelect = (selectedOption) => {
    setTransferReason(selectedOption.label);
  };

  const handleSendAmount = async (sendAmount) => {
    sendAmount = Number(sendAmount);
    if (sendAmount === 0) {
      setReceiveAmount(0);
      setSendAmount(0);
      return;
    }

    setSendAmount(sendAmount?.toFixed(2));
    try {
      // const chargeData = await getChargeAsync(sendAmount);
      // const charges = chargeData?.data?.data;
      //
      // if (charges) {
      //   let chargeAmount =
      //     charges.fixed_charge_amount +
      //     (sendAmount * charges.percentage_charge_amount) / 100;
      //   setCharge(chargeAmount);
      //   setReceiveAmount(Number((sendAmount - chargeAmount) * rate).toFixed(2))
      // } else {
      //   setCharge(0);
      //   setReceiveAmount(Number((sendAmount - charge) * rate).toFixed(2))
      //   // setReceiveAmount(Number(sendAmount * rate).toFixed(2));
      // }
      setReceiveAmount(Number(sendAmount * rate).toFixed(2))
    } catch (err) {
      setReceiveAmount(Number(sendAmount * rate).toFixed(2));
      // setCharge(0);
    }
  };

  const handleReceiveAmount = async (receiveAmount) => {
    if (receiveAmount === 0) {
      setSendAmount(0);
      setReceiveAmount(0);
      return;
    }
    setReceiveAmount(Number(receiveAmount).toFixed(2));

    try {
      // const chargeData = await getChargeAsync(receiveAmount / rate);
      // const charges = chargeData?.data?.data;
      // if (charges) {
      //   let chargeAmount =
      //     charges.fixed_charge_amount +
      //     (sendAmount * charges.percentage_charge_amount) / 100;
      //   setCharge(chargeAmount);
      // }
      setSendAmount(Number(receiveAmount / rate).toFixed(2));
    } catch (err) {
      setSendAmount(Number(receiveAmount / rate).toFixed(2));
      // setCharge(0);
    }
  };

  useEffect(() => {
    setAmountToPay((Number(sendAmount) + Number(charge)).toFixed(2));
  }, [charge, sendAmount]);

  const transferOptions = useMemo(() => {
    return transferReasons.map((val) => {
      return { label: val, value: val };
    });
  }, [transferReasons]);

  const filteredReason = useMemo(() => {
    return searchReasonQuery === ""
      ? transferOptions
      : transferOptions.filter((item) =>
          item?.label
            .toLowerCase()
            .replace(/\s+/g, "")
            .includes(searchReasonQuery.toLowerCase().replace(/\s+/g, ""))
        );
  }, [transferOptions, searchReasonQuery]);

  return (
    <>
      <div className="flex items-center gap-4">
        <Button
          variant="outline"
          onClick={() => setCurrentStep((prev) => prev - 1)}
          className="h-8 w-8 p-0 rounded-full bg-white text-blue-600 border border-gray-200 hover:bg-gray-50 shadow-sm"
          aria-label="Back"
        >
          <svg 
            width="16" 
            height="16" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
            className="flex-shrink-0"
          >
            <line x1="19" y1="12" x2="5" y2="12"></line>
            <polyline points="12,19 5,12 12,5"></polyline>
          </svg>
        </Button>

        {/* <Title title={"Amount"} /> */}
      </div>
      <div className="intro-y flex flex-col lg:flex-row items-center max-w-5xl mx-auto gap-6">
        <div className="w-full lg:w-3/5 bg-white border border-[#DEDEDE] flex flex-col py-7 px-4 gap-6">
          <div className="flex md:flex-row flex-col py-6 gap-6 text-theme-32 items-center justify-between">
            <div className="flex flex-col gap-2 items-center">
              <p className="text-sm font-[500]">Send amount</p>
              <CurrencyInput
                  allowNegativeValue={false}
                  autoFocus
                  name="amountToSend"
                  placeholder={`${agencyCurrency?.symbol ?? "$"}0.00`}
                  defaultValue={"0.00"}
                  value={sendAmount ? sendAmount : ""}
                  decimalsLimit={2}
                  onValueChange={(value) =>
                      !isNaN(Number(value)) && handleSendAmount(Number(value))
                  }
                  className="text-center w-full border-none amount-to-send  outline-none focus:border-none text-[3rem] font-semibold"
                  prefix={agencyCurrency?.symbol}
                  step={"0.1"}
                  min={0}
              />
            </div>

            <div className="flex flex-col gap-2 items-center">
              <p className="text-sm font-[500]">Receive amount</p>
              <CurrencyInput
                  name="receiveAmount"
                  placeholder={`${disbursal_country?.currency_symbol ?? "$"}0.00`}
                  defaultValue={"0.00"}
                  value={receiveAmount ? receiveAmount : ""}
                  decimalsLimit={2}
                  onValueChange={(value) =>
                      !isNaN(Number(value)) && handleReceiveAmount(Number(value))
                  }
                  className="text-center w-full border-none amount-to-send  outline-none focus:border-none text-[3rem] font-semibold"
                  prefix={disbursal_country?.currency_symbol}
                  step={"0.1"}
                  min={0}
              />
            </div>
          </div>

          <ul className="border border-[#DEDEDE] rounded flex flex-col">
            <li className="flex items-center cursor-pointer justify-between px-6 py-3">
              <div className="flex flex-col w-full items-start gap-2">
                <div className="flex w-full items-center gap-2">
                  <SelectComponent
                      labelName={"Transfer Reason"}
                      data={filteredReason}
                      searchQuery={searchReasonQuery}
                      setSearchQuery={setSearchReasonQuery}
                      displayValue={(item) => transferReason}
                      onChange={(e) => handleReasonSelect(e)}
                      value={transferReason}
                  >
                    {filteredReason.length === 0 && !searchReasonQuery && (
                        <div className="relative cursor-default select-none py-2 px-4 text-gray-700">
                          Nothing found.
                        </div>
                    )}

                    {filteredReason.length === 0 && searchReasonQuery !== "" ? (
                        <div className="relative cursor-default select-none py-2 px-4 text-gray-700">
                          Nothing found.
                        </div>
                    ) : (
                        filteredReason.map((item, index) => (
                            <Combobox.Option
                                key={index}
                                className={({active}) =>
                                    `relative cursor-default select-none py-2 pl-10 pr-4 ${
                                        active
                                            ? "text-[#0042C6] bg-[#0042C61a]"
                                            : "text-gray-900"
                                    }`
                                }
                                value={item}
                            >
                              {({selected, active}) => (
                                  <>
                              <span
                                  className={`block truncate ${
                                      selected ? "font-medium" : "font-normal"
                                  }`}
                              >
                                {item?.label}
                              </span>
                                    {selected ? (
                                        <span
                                            className={`absolute inset-y-0 left-0 flex items-center pl-3 ${
                                                active ? "text-black" : ""
                                            }`}
                                        >
                                  <Check
                                      className="h-5 w-5"
                                      aria-hidden="true"
                                  />
                                </span>
                                    ) : null}
                                  </>
                              )}
                            </Combobox.Option>
                        ))
                    )}
                  </SelectComponent>
                </div>
              </div>
            </li>

            <hr className="bg-[#DEDEDE] text-[#DEDEDE] border-[#DEDEDE]"/>
          </ul>

          <div className="">
            <Button
                disabled={sendAmount <= 0 || receiveAmount <= 0 || !transferReason}
                onClick={() => {
                  if (!transferReason) {
                    addToast("Please select a transfer reason", {
                      appearance: "error",
                      autoDismiss: true,
                      autoDismissTimeout: 5000,
                    });

                    return;
                  }

                  setCurrentStep(6);
                }}
                className={"primary-btn-2 bg-[#0042C6] w-full justify-center"}
            >
              Send Money
            </Button>
          </div>
        </div>
        <div className="w-full lg:w-2/5 intro-y col-span-12 lg:col-span-3">
          <div className="intro-y bg-white border border-gray-200 rounded-lg shadow-sm p-6">
            <div className="text-center mb-6">
              <h3 className="text-lg font-semibold text-gray-900">Transaction Summary</h3>
            </div>

            <div className="space-y-4">
              <div className="flex justify-between items-center py-3 border-b border-gray-100">
                <span className="text-sm text-gray-600">Exchange Rate</span>
                <span className="text-sm font-medium text-gray-900">
                  {agencyCurrency?.symbol} 1 = {disbursal_country?.currency_symbol} {rate}
                </span>
              </div>
              
              <div className="flex justify-between items-center py-3 border-b border-gray-100">
                <span className="text-sm text-gray-600">Transaction Fee</span>
                <span className="text-sm font-medium text-gray-900">
                  {agencyCurrency?.symbol} {charge?.toFixed(2)}
                </span>
              </div>

              <div className="flex justify-between items-center py-3 border-b border-gray-100">
                <span className="text-sm text-gray-600">Admin Commission</span>
                <span className="text-sm font-medium text-green-600">
                  + {agencyCurrency?.symbol} {companyCommissionAmount?.toFixed(2)}
                </span>
              </div>
              
              <div className="flex justify-between items-center py-3 border-b border-gray-100">
                <span className="text-sm text-gray-600">Agent Commission</span>
                <span className="text-sm font-medium text-green-600">
                  + {agencyCurrency?.symbol} {agentCommissionAmount?.toFixed(2)}
                </span>
              </div>
              
              <div className="flex justify-between items-center py-3 border-b border-gray-100">
                <span className="text-sm text-gray-600">Agency Commission</span>
                <span className="text-sm font-medium text-green-600">
                  + {agencyCurrency?.symbol} {agencyCommissionAmount?.toFixed(2)}
                </span>
              </div>

              <div className="flex justify-between items-center py-4 mt-6 bg-blue-50 rounded-lg px-4">
                <span className="font-semibold text-gray-900">Total Amount</span>
                <span className="font-bold text-xl text-blue-600">
                  {agencyCurrency?.symbol} {Number(amountToPay).toFixed(2)}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SendMoney;
